export const weekdayPrefixes = ['sun', 'mon', 'tues', 'wed', 'thu', 'fri', 'sat'];
export const combined = 'combinedtotal';
export const total = 'total';
export const refused = 'refusedtotal';
export const weekdayHeaders = ['S', 'M', 'T', 'W', 'Th', 'F', 'S'];